import React from "react";
import { useNavigate } from "react-router-dom";
import "./loginSignUpLayout.css";
import logo from "../../assets/logo-dark.png";

function LoginSignUpLayout({ children }) {
  const navigate = useNavigate();
  return (
    <div className="orion__container">
      <div className="orion__modal">
        <div className="orion__logo-container" onClick={() => navigate("/")}>
          <img className="orion__logo" src={logo} alt="logo"></img>
        </div>
        {children}
      </div>
    </div>
  );
}

export default LoginSignUpLayout;
